import { Component, OnInit, Input } from '@angular/core';
import { SearchProjectsService } from '../services/search-projects.service';
import { IOptions } from '../interfaces/options.interface';
export class GitProjectListComponent implements OnInit {

   options: IOptions;
private selectedUser: any;
private repositories: any;
/**
 * @param {?} searchService
 */
constructor(private searchService: SearchProjectsService) {

    // Récupère le nom d'utilisateur git et recherche toutes les informations liés à cet utilisateur
    this.searchService.getDetailsByUserName(this.options.username).then((data) => {
      this.selectedUser = data;
    });

    this.searchService.getRepositoriesDetailsByUserName(this.options.username).then((data) => {
      this.repositories = data;
    });

   }
/**
 * @return {?}
 */
ngOnInit() {
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'git-project-list',
  templateUrl: './git-project-list.component.html',
  styleUrls: ['./git-project-list.component.css'],
  providers: [SearchProjectsService]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SearchProjectsService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'options': [{ type: Input },],
};
}

function GitProjectListComponent_tsickle_Closure_declarations() {
/** @type {?} */
GitProjectListComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
GitProjectListComponent.ctorParameters;
/** @type {?} */
GitProjectListComponent.propDecorators;
/** @type {?} */
GitProjectListComponent.prototype.options;
/** @type {?} */
GitProjectListComponent.prototype.selectedUser;
/** @type {?} */
GitProjectListComponent.prototype.repositories;
/** @type {?} */
GitProjectListComponent.prototype.searchService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
